/**
 * 销售主管 - 批次统计（团队下客户结算批次）
 */
<template>
  <div class="sales-supervisor-batch">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/salesSupervisor/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>批次统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户类型">
          <el-select v-model="formInline.agentType" placeholder="全部" clearable>
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.disCompanyName"
            placeholder="请输入服务商名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="电销">
          <el-select
            v-model="formInline.phoneSalesId"
            placeholder="请选择电销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面销">
          <el-select
            v-model="formInline.faceSalesId"
            placeholder="请选择面销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属地">
          <el-select
            v-model="formInline.phoneSalesLocation"
            placeholder="全部"
            clearable
          >
            <el-option label="北京" value="北京"></el-option>
            <el-option label="石家庄" value="石家庄"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点">
          <el-select v-model="formInline.hasRebate" placeholder="全部" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      
    </div>

    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="exportdata">导出数据</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <!-- F011: 阶梯/比例未配置提示(§9 #9), 不中断列表加载 -->
      <el-alert
        v-if="commissionStatus === 'configMissing'"
        :title="commissionError || '请先配置阶梯/比例'"
        type="warning"
        :closable="false"
        show-icon
        class="commission-config-alert"
      />
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
      <el-table-column fixed prop="batchNumber" label="批次号" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.batchNumber)">{{ scope.row.batchNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed prop="merchantName" label="商户名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">{{ scope.row.merchantName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip></el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip></el-table-column>
      <el-table-column prop="serviceFee" label="服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee ? scope.row.serviceFee.toFixed(2) : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="managementFee" label="管理费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.managementFee ? scope.row.managementFee.toFixed(2) : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="managementFeeRate" label="管理费率" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amountReceived" label="实际到账" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.amountReceived ? scope.row.amountReceived.toFixed(2) : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bottomRate" label="底价" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.bottomRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actualQuotePrice" label="实际报价" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.actualQuotePrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.rebate != null && scope.row.rebate !== '' && Number(scope.row.rebate) !== 0
                  ? '#f56c6c'
                  : '#909399',
            }"
          >
            {{ formatRate(scope.row.rebate) || '0.00%' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="managementFeeMode" label="管理费承担" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column prop="individualIncomeTaxMode" label="个税承担" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2">个人承担</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="提成" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatMoney4(scope.row.commission) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="grossProfit" label="毛利" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatMoney4(scope.row.grossProfit) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="distributeCompanyName" label="服务商" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.distributeCompanyName)">
            {{ scope.row.distributeCompanyName }}
          </span>
        </template>
      </el-table-column>
    </el-table>

      <!-- F011: 主管视图合计(AC-011-02), 空列表也展示 0 -->
      <div class="summary-panel">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">总服务费：</span>
              <span class="summary-value">{{ formatNumber(currentPageSummary.totalServiceFee) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">总管理费：</span>
              <span class="summary-value">{{ formatNumber(currentPageSummary.totalManagementFee) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">团队总毛利：</span>
              <span class="summary-value">{{ formatMoney4(currentPageSummary.totalGrossProfit) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">主管提成：</span>
              <span class="summary-value">{{ formatMoney4(currentPageSummary.totalCommission) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
        class="pagination-wrap"
      ></Pagination>
    </el-card>

    <!-- T-043 (REQ-015 F004): 团队其他批次列表(ocb 数据源, 同菜单同页面不新建菜单, 复制改造不抽共用组件 Q4 拍板) -->
    <div class="ocb-section-title">其他批次列表</div>
    <div class="search-section ocb-search-section">
      <el-form :inline="true" :model="ocbFormInline" size="small" class="search-form">
        <el-form-item label="商户类型">
          <el-select v-model="ocbFormInline.agentType" placeholder="全部" clearable>
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            v-model="ocbFormInline.merchantName"
            placeholder="请输入商户名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="ocbFormInline.disCompanyName"
            placeholder="请输入服务商名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="电销">
          <el-select
            v-model="ocbFormInline.phoneSalesId"
            placeholder="请选择电销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面销">
          <el-select
            v-model="ocbFormInline.faceSalesId"
            placeholder="请选择面销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属地">
          <el-select
            v-model="ocbFormInline.phoneSalesLocation"
            placeholder="全部"
            clearable
          >
            <el-option label="北京" value="北京"></el-option>
            <el-option label="石家庄" value="石家庄"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点">
          <el-select v-model="ocbFormInline.hasRebate" placeholder="全部" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="ocbFormInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="ocbSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="ocbReset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- BUG-001: ocb 时间筛选由结算月份改为结算时间范围(后端映射为结算月份闭区间, ocb 仅月份粒度), 与原列表对齐 -->
      <div class="ocb-month-tip">其他批次按结算时间范围查询（不选=全量；批次粒度为结算月份，落在范围内即命中）；行级提成 = 行贡献（主管本人批次行提成 0，与原列表一致）</div>
    </div>

    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="ocbExport">导出数据</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <!-- F011: 阶梯/比例未配置提示(§9 #9), 不中断列表加载 -->
      <el-alert
        v-if="ocbCommissionStatus === 'configMissing'"
        :title="ocbCommissionError || '请先配置阶梯/比例'"
        type="warning"
        :closable="false"
        show-icon
        class="commission-config-alert"
      />
      <el-table
        size="small"
        :data="ocbListData"
        highlight-current-row
        v-loading="ocbLoading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
      <el-table-column fixed prop="batchNumber" label="批次号" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.batchNumber)">{{ scope.row.batchNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed prop="merchantName" label="商户名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">{{ scope.row.merchantName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip></el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip></el-table-column>
      <el-table-column prop="serviceFee" label="服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee ? scope.row.serviceFee.toFixed(2) : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="managementFee" label="管理费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.managementFee ? scope.row.managementFee.toFixed(2) : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="managementFeeRate" label="管理费率" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bottomRate" label="底价" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.bottomRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actualQuotePrice" label="实际报价" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.actualQuotePrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.rebate != null && scope.row.rebate !== '' && Number(scope.row.rebate) !== 0
                  ? '#f56c6c'
                  : '#909399',
            }"
          >
            {{ formatRate(scope.row.rebate) || '0.00%' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="提成" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatMoney4(scope.row.commission) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="grossProfit" label="毛利" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatMoney4(scope.row.grossProfit) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="disCompanyName" label="服务商" show-overflow-tooltip>
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.disCompanyName)">
            {{ scope.row.disCompanyName }}
          </span>
        </template>
      </el-table-column>
    </el-table>

      <!-- T-043 (AC-015-15): 底部四统计 = 当页之和, 翻页随当页变化 -->
      <div class="summary-panel">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">总服务费：</span>
              <span class="summary-value">{{ formatNumber(ocbCurrentPageSummary.totalServiceFee) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">总管理费：</span>
              <span class="summary-value">{{ formatNumber(ocbCurrentPageSummary.totalManagementFee) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">团队总毛利：</span>
              <span class="summary-value">{{ formatMoney4(ocbCurrentPageSummary.totalGrossProfit) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <span class="summary-label">主管提成：</span>
              <span class="summary-value">{{ formatMoney4(ocbCurrentPageSummary.totalCommission) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <Pagination
        v-bind:child-msg="ocbPageparm"
        @callFather="ocbCallFather"
        class="pagination-wrap"
      ></Pagination>
    </el-card>
  </div>
</template>

<script>
import { getSalesTeamSettlementBatch, getSalesTeamOtherChannelBatch, getTeamSalesList } from '../../api/userMG';
import Pagination from '../../components/Pagination';

export default {
  name: 'SalesSupervisorSalesBatchStatistics',
  components: { Pagination },
  data() {
    return {
      merchantTypeList: [
        { label: '普通商户', value: 1 },
        { label: '代理商户', value: 2 },
      ],
      salesOptions: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      loading: false,
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        phoneSalesLocation: '',
        startDate: '',
        endDate: '',
        agentType: '',
        hasRebate: '',
        date: [],
      },
      listData: [],
      // F011/F012: 整月值保留(接口仍返回, 回写依赖; T-023 REQ-006 起底部统计改绑 currentPageSummary 当前页总和, 不再消费整月值)
      teamGrossProfit: 0, // 团队当月总毛利(接口整月值, AC-011-02)
      leaderCommission: 0, // 主管提成(团队总毛利×档位比例, 接口整月值)
      commissionStatus: 'ok', // ok=正常 / configMissing=阶梯未配置(§9 #9)
      commissionError: '', // 配置缺失文案
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      // T-043 (REQ-015 F004): 团队其他批次列表(ocb); BUG-001: 时间范围替代结算月份
      ocbLoading: false,
      ocbFormInline: {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        phoneSalesLocation: '',
        agentType: '',
        hasRebate: '',
        startDate: '',
        endDate: '',
        date: [],
      },
      ocbListData: [],
      ocbCommissionStatus: 'ok', // ok=正常 / configMissing=阶梯未配置(§9 #9)
      ocbCommissionError: '',
      ocbPageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  computed: {
    // T-043 (AC-015-15): 其他批次底部四统计 = 当页之和, 翻页随当页变化
    ocbCurrentPageSummary() {
      return this.ocbListData.reduce(
        (acc, item) => {
          acc.totalServiceFee += Number(item.serviceFee || 0);
          acc.totalManagementFee += Number(item.managementFee || 0);
          acc.totalCommission += Number(item.commission || 0);
          acc.totalGrossProfit += Number(item.grossProfit != null ? item.grossProfit : 0);
          return acc;
        },
        {
          totalServiceFee: 0,
          totalManagementFee: 0,
          totalCommission: 0,
          totalGrossProfit: 0,
        }
      );
    },
    currentPageSummary() {
      return this.listData.reduce(
        (acc, item) => {
          acc.totalServiceFee += Number(item.serviceFee || 0);
          acc.totalManagementFee += Number(item.managementFee || 0);
          acc.totalCommission += Number(item.commission || 0);
          acc.totalGrossProfit += Number(item.grossProfit != null ? item.grossProfit : 0);
          return acc;
        },
        {
          totalServiceFee: 0,
          totalManagementFee: 0,
          totalCommission: 0,
          totalGrossProfit: 0,
        }
      );
    },
  },
  created() {
    this.fetchSalesOptions();
    this.getdata(this.formInline);
    this.ocbGetData();
  },
  methods: {
    copyToClipboard(text) {
      if (text == null) return;
      const str = String(text);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(str).then(
          () => this.$message({ message: '已复制', type: 'success' }),
          () => this.$message.error('复制失败，请重试！')
        );
      } else {
        const input = document.createElement('textarea');
        input.value = str;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
          this.$message({ message: '已复制', type: 'success' });
        } catch (err) {
          this.$message.error('复制失败，请重试！');
        }
        document.body.removeChild(input);
      }
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        phoneSalesLocation: '',
        agentType: '',
        hasRebate: '',
        date: [],
      };
      this.getdata(this.formInline);
    },
    fetchSalesOptions() {
      getTeamSalesList({ page: 1, pageSize: 9999, saleName: '' })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.salesOptions = Array.isArray(data.items) ? data.items : [];
          } else {
            this.salesOptions = [];
          }
        })
        .catch(() => {
          this.salesOptions = [];
        });
    },
    getdata(formInline) {
      this.loading = true;
      if (formInline.date && formInline.date.length === 2) {
        formInline.startDate = formInline.date[0] || '';
        formInline.endDate = formInline.date[1] || '';
      } else {
        formInline.startDate = '';
        formInline.endDate = '';
      }
      const params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        phoneSalesId: formInline.phoneSalesId,
        faceSalesId: formInline.faceSalesId,
        phoneSalesLocation: formInline.phoneSalesLocation,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
        hasRebate: formInline.hasRebate === '' ? undefined : formInline.hasRebate,
      };
      getSalesTeamSettlementBatch(params)
        .then((res) => {
          this.loading = false;
          if (res.msg === 'success' || res.code === 0) {
            const data = res.data || {};
            this.listData = Array.isArray(data.items) ? data.items : [];
            this.pageparm.page = data.page != null ? data.page : formInline.page;
            this.pageparm.pageSize = data.pageSize != null ? data.pageSize : formInline.pageSize;
            this.pageparm.total = data.totalCount != null ? data.totalCount : 0;
            // F011: 消费 API-018 新字段(AC-011-02, §9 #9)
            this.teamGrossProfit = data.teamGrossProfit != null ? data.teamGrossProfit : 0;
            this.leaderCommission = data.leaderCommission != null ? data.leaderCommission : 0;
            this.commissionStatus = data.commissionStatus || 'ok';
            this.commissionError = data.commissionError || '';
          } else {
            this.$message({ type: 'error', message: res.msg || '请求失败' });
            this.listData = [];
          }
        })
        .catch(() => {
          this.loading = false;
          this.listData = [];
        });
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // T-043 (REQ-015 F004): 团队其他批次列表数据(ocb, /v1/sales/team/other-channel-batch)
    ocbGetData() {
      this.ocbLoading = true;
      const f = this.ocbFormInline;
      // BUG-001: 时间范围(yyyy-MM-dd)替代结算月份, 后端映射为结算月份闭区间
      if (f.date && f.date.length === 2) {
        f.startDate = f.date[0] || '';
        f.endDate = f.date[1] || '';
      } else {
        f.startDate = '';
        f.endDate = '';
      }
      const params = {
        page: f.page,
        pageSize: f.pageSize,
        merchantName: f.merchantName,
        disCompanyName: f.disCompanyName,
        phoneSalesId: f.phoneSalesId,
        faceSalesId: f.faceSalesId,
        phoneSalesLocation: f.phoneSalesLocation,
        agentType: f.agentType,
        hasRebate: f.hasRebate === '' ? undefined : f.hasRebate,
        startDate: f.startDate,
        endDate: f.endDate,
      };
      getSalesTeamOtherChannelBatch(params)
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            const data = res.data || {};
            this.ocbListData = Array.isArray(data.items) ? data.items : [];
            this.ocbPageparm.page = data.page != null ? data.page : f.page;
            this.ocbPageparm.pageSize = data.pageSize != null ? data.pageSize : f.pageSize;
            this.ocbPageparm.total = data.totalCount != null ? data.totalCount : 0;
            this.ocbCommissionStatus = data.commissionStatus || 'ok';
            this.ocbCommissionError = data.commissionError || '';
          } else {
            this.$message({ type: 'error', message: res.msg || '请求失败' });
          }
          this.ocbLoading = false;
        })
        .catch(() => {
          this.ocbLoading = false;
        });
    },
    // T-043: 其他批次分页事件
    ocbCallFather(parm) {
      this.ocbFormInline.page = parm.page;
      this.ocbFormInline.pageSize = parm.pageSize;
      this.ocbGetData();
    },
    // T-043: 其他批次搜索事件(与原列表行为一致, 重置页码)
    ocbSearch() {
      this.ocbFormInline.page = 1;
      this.ocbGetData();
    },
    // T-043: 其他批次重置事件
    ocbReset() {
      this.ocbFormInline = {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        phoneSalesLocation: '',
        agentType: '',
        hasRebate: '',
        startDate: '',
        endDate: '',
        date: [],
      };
      this.ocbGetData();
    },
    // T-043 (AC-015-14): 其他批次导出(export=1, pageSize 99999 与原列表口径一致)
    ocbExport() {
      const f = this.ocbFormInline;
      // BUG-001: 时间范围(yyyy-MM-dd)替代结算月份, 后端映射为结算月份闭区间
      if (f.date && f.date.length === 2) {
        f.startDate = f.date[0] || '';
        f.endDate = f.date[1] || '';
      } else {
        f.startDate = '';
        f.endDate = '';
      }
      const params = {
        page: 1,
        pageSize: 99999,
        merchantName: f.merchantName,
        disCompanyName: f.disCompanyName,
        phoneSalesId: f.phoneSalesId,
        faceSalesId: f.faceSalesId,
        phoneSalesLocation: f.phoneSalesLocation,
        agentType: f.agentType,
        hasRebate: f.hasRebate === '' ? undefined : f.hasRebate,
        startDate: f.startDate,
        endDate: f.endDate,
        export: 1,
      };
      getSalesTeamOtherChannelBatch(params)
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({ type: 'error', message: '导出链接为空，请联系管理员' });
            }
          } else {
            this.$message({ type: 'error', message: res.msg || '导出失败' });
          }
        })
        .catch(() => this.$message({ type: 'error', message: '导出失败' }));
    },
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find((item) => item.value === agentType);
      return type ? type.label : '未知';
    },
    exportdata() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || '';
        this.formInline.endDate = this.formInline.date[1] || '';
      } else {
        this.formInline.startDate = '';
        this.formInline.endDate = '';
      }
      const params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        phoneSalesId: this.formInline.phoneSalesId,
        faceSalesId: this.formInline.faceSalesId,
        phoneSalesLocation: this.formInline.phoneSalesLocation,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        hasRebate: this.formInline.hasRebate === '' ? undefined : this.formInline.hasRebate,
        export: 1,
      };
      getSalesTeamSettlementBatch(params)
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({ type: 'error', message: '导出链接为空，请联系管理员' });
            }
          } else {
            this.$message({ type: 'error', message: res.msg || '导出失败' });
          }
        })
        .catch(() => this.$message({ type: 'error', message: '导出失败' }));
    },
    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return '';
    },
    formatNumber(num) {
      return num != null ? Number(num).toFixed(2) : '0.00';
    },
    // F011: 提成/毛利 4 位小数展示(契约 API-018 展示层精度)
    formatMoney4(num) {
      const val = Number(num);
      return isNaN(val) ? '0.0000' : val.toFixed(4);
    },
  },
};
</script>

<style scoped>
.sales-supervisor-batch {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}

.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
/* T-025: 提成列口径说明 */
.t025-month-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}

.toolbar {
  margin: 16px 0;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.commission-config-alert {
  margin-bottom: 16px;
}
.table-card >>> .el-card__body {
  padding: 20px;
}

.summary-panel {
  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}
.summary-item {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}
.summary-label {
  margin-right: 4px;
}
.summary-value {
  font-weight: 500;
}

.pagination-wrap {
  margin-top: 16px;
}

/* T-043: 其他批次列表区块标题(REQ-015 F004) */
.ocb-section-title {
  margin-top: 24px;
  padding: 12px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}
.ocb-search-section {
  margin-top: 0;
  border-radius: 0 0 8px 8px;
}
.ocb-month-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/salesSupervisor/salesBatchStatistics.vue